<div class="cliente-congelamento-card-info card">
    <h6 class="card-header card-title" (click)="toggleCollapse()">
        <i class="fas fa-caret-down" aria-hidden="true" *ngIf="!isCollapseOpened"></i>
        <i class="fas fa-caret-up" aria-hidden="true" *ngIf="isCollapseOpened"></i>
        {{title}}
    </h6>
    <div class="card-body" #collapse>
        <div class="row">
            <div class="form-group col-12 col-md-9">
                <label class="col-form-label">Congelado Por</label>
                <input type="text" class="form-control" [value]="usuarioCongelamento?.nome"
                    disabled="disabled" readonly="readonly">
            </div>
            <div class="form-group col-12 col-md-3">
                <label class="col-form-label">Congelado em</label>
                <input type="text" class="form-control text-center" [value]="dataCongelamento | date: 'dd/MM/yyyy - HH:mm:ss'"
                    disabled="disabled" readonly="readonly">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">Motivo</label>
                <input type="text" class="form-control" [value]="motivoCongelamento?.nome"
                    disabled="disabled" readonly="readonly">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">Justificativa</label>
                <textarea class="form-control" [value]="justificativaCongelamento" name="justificativaCongelamento" id="justificativaCongelamento"
                    rows="1" sgtAutosize disabled="disabled" readonly="readonly">
                </textarea>
            </div>
        </div>
    </div>
</div>
